export default function ifEquals(valueOne, valueTwo, options) {
  if (valueOne === valueTwo) {
    return options.fn(this);
  }
  return options.inverse(this);
}